import React, { useEffect, useState, useCallback } from 'react';
import useApp from 'hooks/useApp'
import { Select, Logo, Layer } from 'components'
import styles from '../index.module.css'
import Lib from 'library'
import { financeLoanDetailState_2 } from './states'
import { useRecoilState } from 'recoil'

const FinanceLoanDetailLayer_2 = () => {

	const App = useApp()
	const [layerControl, setLayerControl] = useRecoilState(financeLoanDetailState_2)

	// const seq = layerControl.seq;
	// const dclsMonth = layerControl.dclsMonth;
	// const finCoNo = layerControl.finCoNo;
	// const finPrdtCd = layerControl.finPrdtCd;
	// const house = layerControl.data;
	const friId = layerControl.friId;
	const lendRateMin = layerControl.lendRateMin; // 최저금리
	const [house, setHouse] = useState(null);

	const [rentHouseOpLst, setRentHouseOpLst] = useState(null);

	const [rpayOption, setRpayOption] = useState(null);
	const [lendOption, setLendOption] = useState(null);

	const [rpay, setRpay] = useState("");
	const [lend, setLend] = useState("");

	const [resultLst, setResultLst] = useState(null);

	const [accordionOpen, setAccordionOpen] = useState(true)
	const openAccordion = () => setAccordionOpen(!accordionOpen);

	const rentHouseRate = (data) => {
		console.log(data);

		// 대출상환유형
		const rpayOptions = new Map(data.map(rpay => [rpay.rpayTypeNm]));
		const _rpay = [...rpayOptions].map(([nm]) => ({ 'rpay_type': nm, 'rpay_type_nm': nm }));
		setRpayOption(_rpay);
		// 대출금리유형
		const lendOptions = new Map(data.map(lend => [lend.lendRateTypeNm]));
		const _lend = [...lendOptions].map(([nm]) => ({ 'lend_rate_type': nm, 'lend_rate_type_nm': nm }));
		setLendOption(_lend);

		// 선택, 조회 초기값 적용
		setRpay(_rpay[0].rpay_type);
		setLend(_lend[0].lend_rate_type);
	}

	// 전세 getRentHouseOption
	const getRentHouseOption = (fmiId) => {
		Lib.myGet(`/api/recomm/rentHouse/v1/${fmiId}`, (data) => {
			console.log('전세 상세', data.data)
			setRentHouseOpLst(data.data.options);
			rentHouseRate(data.data.options);
			setHouse(data.data);
		});
		// Lib.post(`/api/finance/rentHouseLoanOption?dclsMonth=${month}&finCoNo=${codeNo}&finPrdtCd=${prdtCode}`, (data) => {
		// 	setRentHouseOpLst(data);
		// 	rentHouseRate(data);
		// });
	}

	useEffect(() => {
		layerControl.show && getRentHouseOption(friId)
	}, [friId, layerControl.show])

	const onResultSeleted = useCallback((key, value, set) => {
		set(value);
	}, [rpay, lend]);

	useEffect(() => {
		const _selectedData = rentHouseOpLst && rentHouseOpLst.find(v => v.rpayTypeNm === rpay && v.lendRateTypeNm === lend);
		setResultLst(_selectedData);
	}, [rpay, lend]);

	return (
		<Layer show={layerControl.show} closeLayer={() => setLayerControl(prev => ({ ...prev, show: false }))}>
			{
				house &&
				<div className="page">
					<div className="shadow">
						<div className="padding">
							<div className="flex-justify_between align_center mt_10">
								<div className={styles["detail-title"]}>
									<span>{house.korCoNm}</span>
									<p className="mt_5">{house.finPrdtNm}</p>
									<i className="tag tag-box tag-red mt_10">전세자금대출</i>
								</div>
								{/* <div className="img-box img-symbol img-symbol-lg ml_10">
									<Logo code={house.fin_co_no} style={{ 'width': '6rem', 'height': '6rem' }} />
								</div> */}
							</div>
							<ul className={`${styles["count-list"]} mt_20`}>
								<li style={house.loanLmt.split('\n').length > 10 ? { 'width': '16rem' } : {}}>
									<p>최저금리</p>
									<strong>{!lendRateMin ? "-" : `${Number(lendRateMin).toFixed(2)}%`}</strong>
								</li>
								{/* <li style={house.loanLmt.split('\n').length > 10 ? { 'width': '16rem' } : {}}>
									{!house.minRate ? (
										<>
											<p>평균금리</p>
											<strong>{!house.lendRateAvg ? "-" : `${Number(house.lendRateAvg).toFixed(2)}%`}</strong>
										</>
									) : (
										<>
											<p>최저금리</p>
											<strong>{!house.minRate ? "-" : `${Number(house.minRate).toFixed(2)}%`}</strong>
										</>
									)}
								</li> */}
								<li style={house.loanLmt.split('\n').length > 10 ? { 'width': 'auto' } : {}}>
									<p>대출한도</p>
									{house.loanLmt.split('\n')
										.map(item => (
										<strong key={item}>
											{item}
										</strong>
									))}
								</li>
							</ul>
						</div>
					</div>
					<div className="shadow">
						<div className="padding">
							<div className={`${accordionOpen ? "active" : ""} accordion-title flex-justify_between align_center`} onClick={openAccordion}>
								<h3>내가 이 대출을 받는다면?</h3>
								<i className="icon icon_accordion_arrow" />
							</div>
							<div className="accordion-content">
								<div className="flex-justify_center mt_40">
									<i className="icon icon_finance_loan" />
								</div>
								<div className={`${styles["question-area"]} mt_20`}>
									<div className={styles.sec}>{house.finPrdtNm} 상품을</div>
									<div className={styles.sec}>
										<Select
											className="mr_10"
											title="대출금리유형"
											selected={lend}
											data={lendOption && lendOption.map(lend => ({ key: `${lend.lend_rate_type_nm}`, value: lend.lend_rate_type }))}
											onSelect={(key, value) => onResultSeleted(key, value, setLend)}
										>
										</Select>
										로
									</div>
									<div className={styles.sec}>
										<Select
											className="mr_10"
											title="대출상환유형"
											selected={rpay}
											data={rpayOption && rpayOption.map(rpay => ({ key: `${rpay.rpay_type_nm}`, value: rpay.rpay_type }))}
											onSelect={(key, value) => onResultSeleted(key, value, setRpay)}
										>
										</Select>
										으로 상환할 경우
									</div>
								</div>
								{resultLst &&
									<div className={`${styles["answer-box"]} mt_20`}>
										{(resultLst.lendRateMin && resultLst.lendRateMax) && (<><strong>{parseFloat(resultLst.lendRateMin).toFixed(2)}% ~ {parseFloat(resultLst.lendRateMax).toFixed(2)}%</strong> 금리를 받아요!<br /></>)}
										전월 취급 평균 금리는 <strong>{parseFloat(resultLst.lendRateAvg).toFixed(2)}%</strong>네요.
									</div>
								}
							</div>
						</div>
					</div>
					<div className="padding">
						<ul className="list-item list-item-left" style={{ fontSize: "1.2rem" }}>
						    {
                                ( house.joinWay != null && house.joinWay != "-" ) &&
                                <li>
                                    <span>가입방법</span>
                                    <span>{house.joinWay}</span>
                                </li>
							}
							{
                                ( house.loanInciExpn != null && house.loanInciExpn != "-" ) &&
                                <li>
                                    <span>대출 부대비용</span>
                                    <span style={{ whiteSpace: "pre-wrap" }}>{house.loanInciExpn}</span>
                                </li>
							}
							{
                                ( house.erlyRpayFee != null && house.erlyRpayFee != "-" ) &&
                                <li>
                                    <span>중도상환<br />수수료</span>
                                    <span style={{ whiteSpace: "pre-wrap" }}>{house.erlyRpayFee}</span>
                                </li>
							}
							{
                                ( house.dlyRate != null && house.dlyRate != "-" ) &&
                                <li>
                                    <span>연체 이자율</span>
                                    <span>{house.dlyRate}</span>
                                </li>
							}
							{
                                ( house.dclsStrtDay != null || house.dclsEndDay != null ) &&
                                <li>
                                    <span>공시 기간</span>
                                    <span>{house.dclsStrtDay} ~ {house.dclsEndDay}</span>
                                </li>
							}
						</ul>
						<div className={`${styles["list-guide"]} mt_50`}>금융감독원의 금융상품 API를 통해 제공하는 정보입니다.</div>
					</div>
				</div>
			}
		</Layer>
	)
}

export default FinanceLoanDetailLayer_2